import { render } from "./FunctionsCatalogDatasetTable.vue?vue&type=template&id=18fb5aae&ts=true"
import script from "./FunctionsCatalogDatasetTable.vue?vue&type=script&lang=ts"
export * from "./FunctionsCatalogDatasetTable.vue?vue&type=script&lang=ts"

import "./FunctionsCatalogDatasetTable.vue?vue&type=style&index=0&id=18fb5aae&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__